import { Button, Col, Form, InputNumber, Row, notification } from "antd";
import React, { useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";

const UpdatePlantEfficiency = ({ pcb, plantEfficiencyId }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const updatePlantEfficiency = async (datas) => {
		try {
			setLoading(true);

			const url = api + `/plantefficiency/update/day/${plantEfficiencyId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.patch(url, datas);

			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					setLoading(false);
					pcb();
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			setLoading(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to update plant efficiency"
			);
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		updatePlantEfficiency(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row>
					<Col span={24}>
						<Form.Item
							label="Days"
							name={"days"}
							rules={[
								{
									required: true,
									message: "Days required",
								},
							]}
						>
							<InputNumber
								step={1}
								min={0}
								max={31}
								precision={0}
								size="large"
								style={{ width: "100%" }}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Button
					type="primary"
					htmlType="submit"
					loading={loading}
					disabled={loading}
				>
					Save
				</Button>
			</Form>
		);
	};

	return (
		<div>
			{contextHolder}
			<CustomForm />
		</div>
	);
};

export default UpdatePlantEfficiency;
